import { createContext } from 'react';

const ProspectoContext = createContext();

export default ProspectoContext;